import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import ButtonGroup from "../../ButtonGroup";
import dictionary from "../../../../dictionary";
import {shortCurrency} from "../../../../utils/currency";

import styles from "../button-group.module.scss";
import LegendsTooltip from "../LegendsTooltip";

function Hoodie(props) {
  const {name, content, onChange, current, vendorStyle, currency} = props;

  return (
    <div className={styles.root}>
      <ButtonGroup
        current={current}
        buttons={content}
        onChange={(value) => onChange(name, value)}
        vendorStyle={vendorStyle}
        renderButton={({value, difference}) => (
          <LegendsTooltip
            title={
              <div>
                {value === `bouffant` && (
                  <p style={{fontSize: `13px`}}>
                    Имеет мягкий, объемный ворс с изнаночной стороны, что
                    создает эффект уютного кокона. Воздушная текстура отлично
                    держит тепло. Пожалуй, самая комфортная ткань для холодного
                    сезона.
                  </p>
                )}
                {value === `eyelet` && (
                  <p style={{fontSize: `13px`}}>
                    Имеет гладкую поверхность с лицевой стороны и аккуратную
                    петельку с изнаночной. Плотная и в меру теплая ткань отлично
                    подходит для повседневной носки, не оставляет ворса на
                    одежде. Идеальный трикотаж на весну.
                  </p>
                )}
              </div>
            }
          >
            <span className={styles.value}>
              {dictionary.item[value]}
              {` `}
              {Number.isInteger(difference) &&
                difference !== 0 &&
                value !== current && (
                  <span className={styles.difference}>
                    {difference > 0 && `+`}
                    {difference}{shortCurrency(currency, difference)}
                  </span>
                )}
            </span>
          </LegendsTooltip>
        )}
      />
      <span className={styles.label}>– выберите материал</span>
    </div>
  );
}

Hoodie.propTypes = {
  productName: PropTypes.string,
  department: PropTypes.string,
  category: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      difference: PropTypes.number
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func,
  vendorStyle: PropTypes.string
};

const mapStateToProps = (state) => ({
  currency: state.currency
})

export default connect(mapStateToProps)(Hoodie);
